<template>
  <div :class="ns.b()">
    <z-card
      v-for="item in cards"
      :key="item.key"
      shadow="never"
      :class="[ns.e('card'), { [ns.is('active')]: activeKey === item.key }]"
      @click="emit('filter', item.key)"
    >
      <p :class="ns.e('value')">{{ item.value }}</p>
      <p :class="ns.e('label')">{{ item.label }}</p>
    </z-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNamespace } from '@zoryn/hooks'
import ZCard from '@zoryn/components/card'
import type { TaskFilterStatus, TaskSummaryStats } from '../types'

const props = defineProps<{
  stats: TaskSummaryStats
  activeKey?: TaskFilterStatus
}>()

const emit = defineEmits<{
  filter: [status: TaskFilterStatus]
}>()

const ns = useNamespace('task-center-summary')

const cards = computed(() => [
  { key: 'pending' as const, label: '待办', value: props.stats.pending },
  {
    key: 'processing' as const,
    label: '进行中',
    value: props.stats.processing,
  },
  { key: 'overdue' as const, label: '已逾期', value: props.stats.overdue },
  { key: 'done' as const, label: '今日完成', value: props.stats.doneToday },
])
</script>
